var map = {
	"./cpr1.jpg": 78,
	"./cpr10.jpg": 79,
	"./cpr11.jpg": 37,
	"./cpr12.jpg": 80,
	"./cpr2.jpg": 81,
	"./cpr3.jpg": 82,
	"./cpr4.jpg": 83,
	"./cpr5.jpg": 84,
	"./cpr6.jpg": 85,
	"./cpr7.jpg": 86,
	"./cpr8.jpg": 87,
	"./cpr9.jpg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1701;